import { csx } from '@vtex/admin-ui'

export const styles = {
  radioGroup: csx({
    'div[data-wrap="true"]': {
      flexWrap: 'nowrap',
    },
    'input[type="radio"]': {
      minWidth: '1.25rem',
    },
  }),
}
